// extracted by mini-css-extract-plugin
export default {"fieldRoot":"FieldSingleDatePicker_fieldRoot__KcOfL","mobileMargins":"FieldSingleDatePicker_mobileMargins__zVaHy"};